import { render, staticRenderFns } from "./DeliveryHourForm.vue?vue&type=template&id=742d27bc"
import script from "./DeliveryHourForm.vue?vue&type=script&lang=ts"
export * from "./DeliveryHourForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports